import React from 'react'
import { PlaceCity } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import BaseOfferCard from './BaseOfferCard'

export default function LocationsCard() {
  const { t } = useTranslation()
  return (
    <BaseOfferCard
      data-testid="locations-card"
      title={t('apac.nlihp.offers.location-card.heading', 'Locations')}
      description={t(
        'apac.nlihp.offers.location-card.subheading',
        'We offer family history help: online and in-person.'
      )}
      Icon={PlaceCity}
      to="https://locations.familysearch.org/en/search?qp=My+Location&r=100"
      external
      linkName="button: locations: click"
    />
  )
}
